import * as angular from 'angular';
import { ManageUsersCreateNewUserModalCtrl } from './manage-users-create-or-edit-user-modal.controller';
import { ManageUsersCreateOrEditUserModal } from './manage-users-create-or-edit-user-modal.service';

export const ManageUsersCreateNewUserModalModule = angular
  .module('manageUsersCreateOrEditUserModal', [])
  .controller('ManageUsersCreateNewUserModalCtrl', ManageUsersCreateNewUserModalCtrl)
  .service('ManageUsersCreateOrEditUserModal', ManageUsersCreateOrEditUserModal).name;
